import { StepType } from '@pushly/models/lib/enums/journeys'
import { LAYOUT_CONSTANTS } from './elk-config'
import { CONVERGENCE_PLACEHOLDER_SIZE, PERF_CARD_WIDTH, PERF_CARD_HEIGHT } from '../constants'
import { JourneyNode, isPerfCardNode } from '../types/journey-nodes'

export function isConvergencePlaceholderNode(node?: JourneyNode): boolean {
    return !!node
        && node.data.step.type === StepType.PLACEHOLDER
        && node.data.uiMeta?.placeholderRole === 'convergence'
}

export function getNodeLayoutDimensions(node?: JourneyNode): { width: number; height: number } {
    if (isConvergencePlaceholderNode(node)) {
        return {
            width: CONVERGENCE_PLACEHOLDER_SIZE,
            height: CONVERGENCE_PLACEHOLDER_SIZE,
        }
    }

    // Synthetic per-variant perf cards use fixed pre-measure dimensions so the
    // first ELK pass is geometrically accurate (mirrors the convergence-placeholder
    // mechanism). Fixed size also equalizes lanes.
    if (isPerfCardNode(node)) {
        return {
            width: PERF_CARD_WIDTH,
            height: PERF_CARD_HEIGHT,
        }
    }

    return {
        width: node?.measured?.width ?? LAYOUT_CONSTANTS.MIN_NODE_WIDTH,
        height: node?.measured?.height ?? LAYOUT_CONSTANTS.MIN_NODE_HEIGHT,
    }
}
